import { useEffect, useState } from 'react';

/**
 * Holds a value back until it has stopped changing for `delayMs`.
 *
 * Switching to the Financial tab re-bases the global date range onto whole
 * completed months (MONTHS_ONLY_TABS), so a single click changes the tab and
 * then the dates a beat later. Without this the panel fires two generations for
 * one user action — and each one is a paid model call.
 */
export const useSettledValue = <T>(value: T, delayMs = 400): T => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
    // Serialized so a new object identity with the same contents does not
    // restart the timer on every render.
  }, [JSON.stringify(value), delayMs]);

  return settled;
};
